<template>
  <BasicPoster class="site-poster" @initializedUser="initPoster">
    <div class="detail">
      <div class="site-bg">
        <img class="site-img-bg" src="@/assets/images/bg_pic.png" />
        <div class="site-img-container">
          <img class="site-gauss-img" :src="storeInfo.gaussImg" />
          <img class="site-img" :src="storeInfo.mainImage" />
          <div class="site-name">{{ storeInfo.name }}</div>
        </div>
      </div>
      <div class="user">
        <img class="user-avatar" :src="userInfo.userAvatarImg" alt="" />
        <div class="user-info">
          <span class="user-name">{{ userInfo.userName }}:</span>
          <span class="user-slogan">{{ singleClockInText }}</span>
        </div>
      </div>
      <img class="qrcode" :src="qrcodeUrl" />
      <span class="qrcode-tips">扫码进入{{ storeInfo.activityName }}</span>
    </div>
  </BasicPoster>
</template>

<script>
import BasicPoster from '../BasicPoster'
import { mapGetters, mapMutations } from 'vuex'
import { loadImg } from '../../../../utils/loadImg'
import { qrcanvas } from 'qrcanvas'
import { getStoreClockIn } from '../../../../server/interfaces'
import { getBase64Img } from '../../../../utils/getBase64Image'
import getGaussImg from '../../../../utils/getGaussImg'
const logo = require('../../../../assets/images/logo.png')

export default {
  name: 'SitePoster',
  components: { BasicPoster },
  data () {
    return {
      qrcodeUrl: '',
      storeInfo: {
        mainImage: '',
        gaussImg: '',
        name: '',
        activityName: '广东红色地图'
      }
    }
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
    ...mapGetters('activityInfo', ['activityInfo', 'activityId']),
    singleClockInText () {
      return this.activityInfo?.mapStyle?.clockInText?.singleClockInText
    },
    shopId () {
      return this.$route.query.shopId
    }
  },
  methods: {
    ...mapMutations({
      showLoading: 'loading/showLoading'
    }),
    async initPoster () {
      await Promise.all([this.getStoreClockIn(), this.getQrcodeUrl()])
      this.storeInfo.mainImage = await getBase64Img(this.storeInfo.mainImage)
      this.storeInfo.gaussImg = await getGaussImg(this.storeInfo.mainImage)
      this.showLoading('海报生成中...')
      await this.$nextTick()
      if (this.activityId) {
        this.$emit('initialized')
      } else {
        const unwatch = this.$watch(
          'activityId',
          id => {
            if (id) {
              this.$emit('initialized')
              unwatch && unwatch()
            }
          },
          { immediate: true }
        )
      }
    },
    async getStoreClockIn () {
      if (!this.shopId) {
        return
      }
      const { storeVO, activityName } = await getStoreClockIn({ storeId: this.shopId })
      this.storeInfo.name = storeVO.name
      this.storeInfo.activityName = activityName
      this.storeInfo.mainImage = storeVO?.redTemplate?.imgs?.[0]?.url
    },
    async getQrcodeUrl () {
      const url = window.location.origin + window.location.pathname
      console.log(url + logo)
      const image = await loadImg(url + logo)
      const canvas = qrcanvas({
        data: decodeURIComponent(
          url +
            this.$router.resolve({
              path: '/homePage',
              query: { id: this.activityId, shopId: this.shopId }
            }).href
        ),
        padding: 12,
        size: 300,
        logo: {
          image
        }
      })
      this.qrcodeUrl = canvas.toDataURL('image/png')
    }
  }
}
</script>

<style lang="scss" scoped>
.site-poster {
  min-height: 9.16rem;
}
.detail {
  display: flex;
  flex-direction: column;
  align-items: center;

  .site-bg {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 6.4rem;
    height: 4.27rem;
    //padding: 0.69rem 0 0.38rem 0;

    .site-img-bg {
      width: 6.4rem;
      height: 4.27rem;
      position: absolute;
      top: 0;
      left: 0;
    }

    .site-img-container {
      width: 5.8rem;
      height: 3.2rem;
      background-size: 100% 100%;
      border-radius: 0.14rem;
      position: relative;
      overflow: hidden;
      z-index: 10;
      margin: 0.69rem 0.3rem 0.38rem 0.3rem;

      .site-img {
        width: auto;
        height: auto;
        max-height: 100%;
        max-width: 100%;
        object-fit: cover;
        position: relative;
        z-index: 10;
      }

      .site-gauss-img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 110%;
        min-height: 110%;
        z-index: 9;
      }

      .site-name {
        position: absolute;
        z-index: 12;
        bottom: -0.02rem;
        width: 5.8rem;
        overflow: hidden;
        box-sizing: border-box;
        padding: 0.22rem 0.25rem 0.22rem 0.25rem;
        color: #ffffff;
        font-size: 0.34rem;
        font-family: FZZDHJW;
        background-image: linear-gradient(rgba(255, 128, 0, 0) 0%, #c80f0f 100%);
        background-size: 5.8rem 105%;
        background-position: bottom center;
        text-align: left;
        word-break: break-all;
      }
    }
  }

  .user {
    padding: 0 0.5rem;
    display: flex;
    justify-content: flex-start;
    width: 100%;

    .user-avatar {
      width: 0.6rem;
      height: 0.6rem;
      border: 0.04rem solid #ffffff;
      border-radius: 50%;
      margin-top: 0.08rem;
    }

    .user-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-left: 0.24rem;
      font-size: 0.28rem;
      line-height: 0.34rem;
      color: #b23f00;
      text-align: left;

      .user-name {
        font-weight: bold;
      }
    }
  }

  .qrcode {
    width: 1.6rem;
    height: 1.6rem;
    margin-top: 0.62rem;
  }

  .qrcode-tips {
    font-weight: bold;
    font-size: 0.24rem;
    color: #b91f1a;
    letter-spacing: 0;
    line-height: 0.34rem;
    padding: 0.1rem 0 0.2rem 0;
  }
}
</style>
